// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import {
    Directive,
    Output,
    EventEmitter,
    HostBinding,
    HostListener
  } from '@angular/core';
  
  @Directive({
    selector: '[appDndDropFile]',
    standalone: false
})

  export class DndDropFileDirective {
    @HostBinding('class.fileover') fileOver: boolean;
    @Output() fileDropped: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() dragOver: EventEmitter<null> = new EventEmitter<null>();
    @Output() dragLeave: EventEmitter<null> = new EventEmitter<null>();

    styles = {
      'border': 'solid 1px rgba(0, 0, 0, 0.3)'
    }

    // Dragover listener
    @HostListener('dragover', ['$event']) onDragOver(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.fileOver = true;
      this.dragOver.emit();
    }
  
    // Dragleave listener
    @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.fileOver = false;
      this.dragLeave.emit();
    }
  
    // Drop listener
    @HostListener('drop', ['$event']) public ondrop(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.fileOver = false;
      let files = evt.dataTransfer.files;
      if (files.length > 0) {
        this.fileDropped.emit(files);
      }
    }
  }